export const SMOKING = {
  OK: {
    value: 'smoking',
    title: '喫煙',
  },
  ONLY_HEATED: {
    value: 'only_heated_smoking',
    title: '喫煙<br />(加熱式たばこ限定)',
  },
  NG: {
    value: 'no_smoking',
    title: '禁煙',
  },
};

export const CONNECT = {
  OK: {
    value: 'on',
    title: '可',
  },
  NG: {
    value: 'off',
    title: '不可',
  },
};

export const SEAT_TYPE = {
  NONE: {
    // なんらかの原因で本来存在しないはずの seatId === 0 のspotがデータ上存在するので、その暫定対応
    value: '0',
    title: '',
  },
  TABLE: {
    value: '1',
    title: 'テーブル',
  },
  COUNTER: {
    value: '2',
    title: 'カウンター',
  },
  PRIVATE_ROOM: {
    value: '3',
    title: '個室',
  },
  TATAMI_ROOM: {
    value: '4',
    title: '座敷',
  },
  HORIGOTATSU: {
    value: '5',
    title: '掘りごたつ',
  },
  SHEETS_FOR_COUPLE: {
    value: '6',
    title: 'カップルシート',
  },
  SOFA: {
    value: '7',
    title: 'ソファー',
  },
  TERRACE: {
    value: '8',
    title: 'テラス',
  },
  COMPLETELY_PRIVATE_ROOM: {
    value: '9',
    title: '完全個室',
  },
  SEMI_PRIVATE_ROOM: {
    value: '10',
    title: '半個室',
  },
};

export const CAPACITY_RANGE = {
  min: 1,
  max: 99,
};

export const CHARGE = {
  NONE: {
    value: 'none',
    title: 'チャージなし',
  },
  PERCENTAGE: {
    value: 'percentage',
    title: '％ チャージあり',
  },
  BY_PERSONS: {
    value: 'by_persons',
    title: '円 チャージあり(人単位)',
  },
  BY_TABLE: {
    value: 'by_table',
    title: '円 チャージあり(テーブル/部屋単位)',
  },
};
